module.exports = __webpack_public_path__ + "bbd269353ec07149568b7f1f73d87a9e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/taiwan-06.png
// module id = 474
// module chunks = 0